import React from "react";
import PropTypes from "prop-types";
import { CloseButton } from "@learningblocks/shared-components/lib/CloseButton";
import "./style.scss";

/**
 * Header:
 *  - Header for LabelTestTube Component
 * @param {Object} props
 * @param {string} [props.className=""]
 * @param {string} [props.label]
 * @param {Function} [props.close]
 * @param {"sm"|"md"|"lg"} [props.size="md"]
 * @param {boolean|number} [props.displayPageNum=false]
 * @param {boolean} [props.displayHeading=false]
 * @param {boolean} [props.displayDate=false]
 */
export function Header({
  className = "",
  label,
  close,
  size = "md",
  displayPageNum = false,
  displayHeading = false,
  displayDate = false,
}) {
  const renderCloseButton = () =>
    close && (
      <CloseButton
        className="component_header__close"
        close={close}
        size={size}
      />
    );
  return (
    <>
      {displayPageNum && (
        <p className="page-num">
          {isNaN(displayPageNum) ? "1" : displayPageNum}
        </p>
      )}
      <div className={`component_header ${className}`}>
        {displayHeading && (
          <p className="headings">Title {displayDate && <span>Date</span>}</p>
        )}
        <h4 className="component_header__label">
          {label}{" "}
          {displayDate && <span>{new Date().toLocaleDateString()}</span>}
        </h4>
        {renderCloseButton()}
      </div>
    </>
  );
}

Header.propTypes = {
  /**
   * className to set on wrapper component
   */
  className: PropTypes.string,
  /**
   * label of the componet
   */
  label: PropTypes.string,
  /**
   * Callback function to invoke when you wanna close the Questio Modal Window
   */
  close: PropTypes.func,
  /**
   * Close Button Size
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Whether to display the page number (boolean) or the specific page number to display (number)
   */
  displayPageNum: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  /**
   * Whether to display the heading
   */
  displayHeading: PropTypes.bool,
  /**
   * Whether to display the date
   */
  displayDate: PropTypes.bool,
};
